import { render, staticRenderFns } from "./DateTimeQuestion.vue?vue&type=template&id=4a5a1f0e"
import script from "./DateTimeQuestion.vue?vue&type=script&lang=js"
export * from "./DateTimeQuestion.vue?vue&type=script&lang=js"
import style0 from "./DateTimeQuestion.vue?vue&type=style&index=0&id=4a5a1f0e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports